import React, { useEffect, useState } from 'react'
import { NavLink, useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import Logo from '../common/Logo'

function Header(): React.JSX.Element {
  const navigate = useNavigate()
  const location = useLocation()
  const { logout, user, isAuthenticated } = useAuth()
  const [menuOpen, setMenuOpen] = useState(false)

  // Close the mobile menu whenever the route changes, so picking an option
  // dismisses it rather than leaving it open over the new page.
  useEffect(() => { setMenuOpen(false) }, [location.pathname])

  const handleLogout = (): void => {
    logout()
    navigate('/login')
  }

  return (
    <header className="header">
      <div className="header-content">
        <Logo />
        {isAuthenticated ? (
          <>
            <nav className="header-nav-main">
              <ul>
                <li>
                  <NavLink to="/" end className="nav-link">My Deliveries</NavLink>
                </li>
                <li>
                  <NavLink to="/delivery-management" className="nav-link">Delivery Management</NavLink>
                </li>
                <li>
                  <NavLink to="/products" className="nav-link">Products</NavLink>
                </li>
                <li>
                  <NavLink to="/pay-online" className="nav-link">Payments</NavLink>
                </li>
              </ul>
            </nav>
            <button
              className="hamburger-menu"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
            <nav className={`header-nav ${menuOpen ? 'active' : ''}`}>
              <ul>
                <li>
                  <NavLink to="/" end className="nav-link-mobile">My Deliveries</NavLink>
                </li>
                <li>
                  <NavLink to="/delivery-management" className="nav-link-mobile">Delivery Management</NavLink>
                </li>
                <li>
                  <NavLink to="/products" className="nav-link-mobile">Products</NavLink>
                </li>
                <li>
                  <NavLink to="/pay-online" className="nav-link-mobile">Payments</NavLink>
                </li>
                <li className="mobile-logout">
                  <button
                    onClick={handleLogout}
                    className="btn-logout"
                  >
                    Logout
                  </button>
                </li>
              </ul>
            </nav>
            <div className="header-user">
              {user && (
                <span className="user-name">
                  {user.name}
                </span>
              )}
              <button
                onClick={handleLogout}
                className="btn-logout desktop-logout"
              >
                Logout
              </button>
            </div>
          </>
        ) : (
          // Anonymous header is intentionally empty: the login page is
          // its own self-contained experience (logo + steps), so a
          // duplicate Login/Register pair in the nav above just adds
          // visual noise. Customers reach /login by visiting the URL,
          // and once signed in the auth-aware branch above renders the
          // user nav as normal.
          null
        )}
      </div>
    </header>
  )
}

export default Header
